import { render, staticRenderFns } from "./FilterInputChoice.vue?vue&type=template&id=b4a61f32&"
import script from "./FilterInputChoice.vue?vue&type=script&lang=ts&"
export * from "./FilterInputChoice.vue?vue&type=script&lang=ts&"
import style0 from "./FilterInputChoice.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports